/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createServerRootRoute } from '@tanstack/react-start/server'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReviewIndexRouteImport } from './routes/review/index'
import { Route as AuthSupportIndexRouteImport } from './routes/_auth/support/index'
import { Route as AuthTripsBookingIdIndexRouteImport } from './routes/_auth/trips.$bookingId/index'
import { ServerRoute as HealthServerRouteImport } from './routes/health'
import { ServerRoute as PwaInitialpageServerRouteImport } from './routes/pwa.initialpage'

const rootServerRouteImport = createServerRootRoute()

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewIndexRoute = ReviewIndexRouteImport.update({
  id: '/review/',
  path: '/review/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSupportIndexRoute = AuthSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTripsBookingIdIndexRoute = AuthTripsBookingIdIndexRouteImport.update({
  id: '/trips/$bookingId/',
  path: '/trips/$bookingId/',
  getParentRoute: () => AuthRoute,
} as any)
const HealthServerRoute = HealthServerRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => rootServerRouteImport,
} as any)
const PwaInitialpageServerRoute = PwaInitialpageServerRouteImport.update({
  id: '/pwa/initialpage',
  path: '/pwa/initialpage',
  getParentRoute: () => rootServerRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/review': typeof ReviewIndexRoute
  '/support': typeof AuthSupportIndexRoute
  '/trips/$bookingId': typeof AuthTripsBookingIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/review': typeof ReviewIndexRoute
  '/support': typeof AuthSupportIndexRoute
  '/trips/$bookingId': typeof AuthTripsBookingIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/review/': typeof ReviewIndexRoute
  '/_auth/support/': typeof AuthSupportIndexRoute
  '/_auth/trips/$bookingId/': typeof AuthTripsBookingIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/review' | '/support' | '/trips/$bookingId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/review' | '/support' | '/trips/$bookingId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/review/'
    | '/_auth/support/'
    | '/_auth/trips/$bookingId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  ReviewIndexRoute: typeof ReviewIndexRoute
}
export interface FileServerRoutesByFullPath {
  '/health': typeof HealthServerRoute
  '/pwa/initialpage': typeof PwaInitialpageServerRoute
}
export interface FileServerRoutesByTo {
  '/health': typeof HealthServerRoute
  '/pwa/initialpage': typeof PwaInitialpageServerRoute
}
export interface FileServerRoutesById {
  __root__: typeof rootServerRouteImport
  '/health': typeof HealthServerRoute
  '/pwa/initialpage': typeof PwaInitialpageServerRoute
}
export interface FileServerRouteTypes {
  fileServerRoutesByFullPath: FileServerRoutesByFullPath
  fullPaths: '/health' | '/pwa/initialpage'
  fileServerRoutesByTo: FileServerRoutesByTo
  to: '/health' | '/pwa/initialpage'
  id: '__root__' | '/health' | '/pwa/initialpage'
  fileServerRoutesById: FileServerRoutesById
}
export interface RootServerRouteChildren {
  HealthServerRoute: typeof HealthServerRoute
  PwaInitialpageServerRoute: typeof PwaInitialpageServerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review/': {
      id: '/review/'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof ReviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/support/': {
      id: '/_auth/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthSupportIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/trips/$bookingId/': {
      id: '/_auth/trips/$bookingId/'
      path: '/trips/$bookingId'
      fullPath: '/trips/$bookingId'
      preLoaderRoute: typeof AuthTripsBookingIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}
declare module '@tanstack/react-start/server' {
  interface ServerFileRoutesByPath {
    '/health': {
      id: '/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof HealthServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/pwa/initialpage': {
      id: '/pwa/initialpage'
      path: '/pwa/initialpage'
      fullPath: '/pwa/initialpage'
      preLoaderRoute: typeof PwaInitialpageServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
  }
}

interface AuthRouteChildren {
  AuthSupportIndexRoute: typeof AuthSupportIndexRoute
  AuthTripsBookingIdIndexRoute: typeof AuthTripsBookingIdIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSupportIndexRoute: AuthSupportIndexRoute,
  AuthTripsBookingIdIndexRoute: AuthTripsBookingIdIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  ReviewIndexRoute: ReviewIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
const rootServerRouteChildren: RootServerRouteChildren = {
  HealthServerRoute: HealthServerRoute,
  PwaInitialpageServerRoute: PwaInitialpageServerRoute,
}
export const serverRouteTree = rootServerRouteImport
  ._addFileChildren(rootServerRouteChildren)
  ._addFileTypes<FileServerRouteTypes>()
